<template>
  <div>
    <div>
      <el-dialog
        v-if="openOff"
        v-dialogStyle
        class="abow_dialog"
        title="特品详情信息列表"
        destroy-on-close
        :visible.sync="openOff"
        center
        :append-to-body="true"
        :lock-scroll="false"
        width="80%"
        @close="close()">
        <productsDetails :orderno="orderno" :name="name" @listenTochildEvent="showMessageFromChild"></productsDetails>
      </el-dialog>
      <DataTables
        :table-data="tableData"
        :table-label="tableLabel"
        :config="config"
        @cellClick="cellClick"
        @searchTable="searchClick(param)"
        @dateChangeEvent="searchClick(param)">
      </DataTables>
    </div>
    <div style="margin-left: 1%;float: left;">
      <span>显示第 1 到第 {{ count }} 条记录，总共 {{ count }} 条记录</span>
    </div>
  </div>

</template>

<script>
import DataTables from '../../../components/pageComponent/DataTables'
import productsDetails from './productsDetails.vue'
import './dialogStyle.js'
export default {
  name: 'productDept',
  components: {
    DataTables,
    productsDetails
  },
  data() {
    return {
      developType: '生产技术',
      count: 0,
      orderno: '',
      name: '',
      openOff: false, //弹出框
      param: '',
      //搜索时触发true
      searchFlag: false,
      // 搜索条件对象
      searchObj: {},
      config: {
        fixed: true,
        sizes: [15, 25, 35],
        dataTotalCount: 0,
        pageSize: 15,
        currentPage: 1,
        loading: true,
        searchTables: true,
        height: '75vh',
        indexWidth: '85%'
      },
      tableData: [],
      tableLabel: [
        {
          label: '份合同号',
          width: '120px',
          prop: 'orderno',
          fixed: true,
          search: ''
        },
        {
          label: '计划名称',
          prop: 'name',
          width: '300px',
          aligin: 'left',
          search: '',
          click: true
        },
        {
          label: '特品号',
          prop: 'specialProductCode',
          width: '120px',
          search: ''
        },
        {
          label: '项目经理',
          prop: 'operator',
          width: '120px',
          search: ''
        },
        {
          label: '开始时间',
          prop: 'startdate',
          width: '120px',
          search: '',
          type: 'Date'
        },
        {
          label: '结束时间',
          prop: 'finishdate',
          width: '120px',
          search: '',
          type: 'Date'
        },
        {
          label: '特品签发时间',
          prop: 'operatDate',
          search: ''
        }
      ]
    }
  },
  created() {
    this.developType = localStorage.getItem('developDeptType') ? localStorage.getItem('developDeptType') : this.developType
    this.getList()
  },
  methods: {
    getList() {
      this.config.loading = true
      const data = {
        developType: this.developType
      }
      this.$fetch('/fesback/productDevelopment/queryUnreleasedProjectList.z', data).then(response => {
        if (response !== '') {
          this.tableData = response
          this.config.loading = false
          this.count = response.length
        } else {
          this.tableData = []
          this.config.loading = false
        }
      })
    },
    //点击弹出
    cellClick(row, column, cell, event) {
      //点击项目弹出
      if (column.label === '计划名称' && row.name) {
        this.orderno = row.orderno
        this.name = row.name
        this.openOff = true
      }
    },
    close() {
      this.openOff = false
    },
    //子组件给父组件传值
    showMessageFromChild() {
      var that = this
      setTimeout(function() {
        that.close()
        that.getList()
      }, 2000)
    }
  }

}

</script>

<style scoped>
.abow_dialog {
    display: flex;
    justify-content: center;
    align-items: Center;
    overflow: hidden;
}
</style>
